// React libraries
import * as React from 'react';
import classnames from 'classnames';
// Custom Styles
import { useStyles } from "./BlueGradientHeaderStyles";
// Icon
import Barcode from "../../../icons/Barcode/Barcode";
export const BlueGradientHeader = (props) => {
    const classes = useStyles(props);
    let height;
    const { type, previewHeight, showScanner } = props;
    const blueGradientHeaderClasses = classnames({
        [classes.blueGradientHeaderSmall]: type === "small" || type === "smallWithSub",
        [classes.blueGradientHeaderBig]: type === "big",
    });
    if (type === "small") {
        height = "75px";
    }
    else if (type === "smallWithSub") {
        height = "90px";
    }
    else {
        height = previewHeight * 50 / 100;
    }
    return (React.createElement("div", { className: blueGradientHeaderClasses, style: { height: height } },
        showScanner && (React.createElement(Barcode, { className: classes.scannerIcon })),
        props.children));
};
export default React.memo(BlueGradientHeader);
